import { applyWrite } from '@/shared/lib/store-write';
import type { Milestone } from '@/modules/rocks/types';

import type { MutationContext } from '@/modules/activity/mutation-context';

export function setMilestoneComplete(
  ctx: MutationContext,
  milestone: Pick<Milestone, 'id' | 'title' | 'rockId' | 'completed' | 'ownerId'>,
  completed: boolean,
  hooks: {
    apply(completed: boolean, completedAt?: string): void;
    rollback(): void;
  },
): void {
  hooks.apply(completed, completed ? new Date().toISOString() : undefined);

  applyWrite(ctx.api(`/milestones/${milestone.id}/complete`, {
    completed,
    unlocked_cycle: ctx.unlockedCycleKey?.() ?? null,
  }), {
    noun: 'this milestone',
    context: 'setMilestoneComplete',
    rollback: hooks.rollback,
  });
}
